import React from "react";
import { Navigate, Outlet, useParams, useSearchParams } from "react-router-dom";

import PageContent from "ui/PageContent";
import {
  useCurrentOrganization,
  useCurrentUser,
} from "providers/WithCurrentOrganization";
import { useRoutes } from "utils/routes";

function WithQueryOrganization() {
  const currentOrganization = useCurrentOrganization(true);
  const { organizations } = useCurrentUser();
  const { queryByFingerprint } = useRoutes();
  const { fingerprint } = useParams();
  const [searchParams] = useSearchParams();

  if (currentOrganization) {
    return <Outlet />;
  }
  if (searchParams.has("organization") || searchParams.has("servergroup")) {
    return <Navigate to="/" replace />;
  }

  const activeOrganizations = organizations.filter(
    (o) =>
      o.enabledFeatures.mergedQueries &&
      [...o.servers, ...o.serverGroups.flatMap((sg) => sg.servers)].some(
        (s) => s.hasRecentSnapshot,
      ),
  );
  if (activeOrganizations.length === 0) {
    return <Navigate to="/" replace />;
  }
  if (activeOrganizations.length === 1) {
    return (
      <Navigate
        to={queryByFingerprint(fingerprint, {
          organization: activeOrganizations[0].slug,
        })}
        replace
      />
    );
  }

  return (
    <PageContent
      windowTitle={`Query ${fingerprint}`}
      title={`View query ${fingerprint}`}
      pageCategory="queries"
      pageName="choose-organization"
    >
      <p>
        Select an organization from the Organization menu to view this query.
      </p>
      <p className="text-sm text-[#595959]">
        Statistics will be limited to servers in the selected organization.
      </p>
    </PageContent>
  );
}

export default WithQueryOrganization;
